var map = {
	"./ar/catalogue.json": 818,
	"./ar/channel.json": 819,
	"./ar/clients.json": 820,
	"./ar/common.json": 821,
	"./ar/dashboard.json": 822,
	"./ar/discountrules.json": 823,
	"./ar/exports.json": 824,
	"./ar/integrations.json": 825,
	"./ar/layout.json": 826,
	"./ar/menuoptions.json": 827,
	"./ar/moncompte.json": 828,
	"./ar/nav.json": 829,
	"./ar/privileges.json": 830,
	"./ar/stock.json": 831,
	"./ar/store.json": 832,
	"./ar/subscribe.json": 833,
	"./en/catalogue.json": 834,
	"./en/channel.json": 835,
	"./en/clients.json": 836,
	"./en/common.json": 837,
	"./en/dashboard.json": 838,
	"./en/discountrules.json": 839,
	"./en/exports.json": 840,
	"./en/integrations.json": 841,
	"./en/layout.json": 842,
	"./en/menuoptions.json": 843,
	"./en/moncompte.json": 844,
	"./en/nav.json": 845,
	"./en/privileges.json": 846,
	"./en/stock.json": 847,
	"./en/store.json": 848,
	"./en/subscribe.json": 849,
	"./fr/catalogue.json": 850,
	"./fr/channel.json": 851,
	"./fr/clients.json": 852,
	"./fr/common.json": 853,
	"./fr/dashboard.json": 854,
	"./fr/discountrules.json": 855,
	"./fr/exports.json": 856,
	"./fr/integrations.json": 857,
	"./fr/layout.json": 858,
	"./fr/menuoptions.json": 859,
	"./fr/moncompte.json": 860,
	"./fr/nav.json": 861,
	"./fr/privileges.json": 862,
	"./fr/stock.json": 863,
	"./fr/store.json": 864,
	"./fr/subscribe.json": 865
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 817;